/**
 * Base ApiEnvironment class for setting the baseUrl
 */
export abstract class ApiEnvironment {
  private baseUrlBacking: null | string;

  set baseUrl(value: string) {
    this.baseUrlBacking = value;
  }

  get baseUrl() {
    if (this.baseUrlBacking === null) {
      throw new ReferenceError('Cannot access "baseUrl" before initialization');
    }

    return this.baseUrlBacking;
  }

  constructor(baseUrl: null | string = null) {
    this.baseUrlBacking = baseUrl;
  }

  abstract resolve(environment: unknown): ApiEnvironment;
}
